// Author thq
// Date 2021-04-16 01:02:24

class EmSppStorageSst {
constructor({
        id = null,
        name = '',
        code = '',
        sstIdSsc = '',
        sstIdDept = '',
        sstIdEloc = '',
        sstKeeperIdUser = '',
        sstIdRemark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.sstIdSsc = sstIdSsc;
    this.sstIdDept = sstIdDept;
    this.sstIdEloc = sstIdEloc;
    this.sstKeeperIdUser = sstKeeperIdUser;
    this.sstIdRemark = sstIdRemark;
}
}

function newEntity() {
return new EmSppStorageSst();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppStorageSst.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppStorageSst.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppStorageSst.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sstNameSsc',
        label: 'label.em.spareparts.emSppStorageSst.grid.sstNameSsc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sstNameDept',
        label: 'label.em.spareparts.emSppStorageSst.grid.sstNameDept',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sstNameEloc',
        label: 'label.em.spareparts.emSppStorageSst.grid.sstNameEloc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sstKeeperNameUser',
        label: 'label.em.spareparts.emSppStorageSst.grid.sstKeeperNameUser',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sstIdRemark',
        label: 'label.em.spareparts.emSppStorageSst.grid.sstIdRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    codeFilter : "",
    sstIdSscFilter : "",
    sstIdDeptFilter : "",
    sstIdElocFilter : "",
    sstKeeperIdUserFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppStorageSst.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.spareparts.emSppStorageSst.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sstIdSscFilter',
        label: 'label.em.spareparts.emSppStorageSst.filter.sstIdSsc',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emSppStorageCatSsc'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'sstIdDeptFilter',
        label: 'label.em.spareparts.emSppStorageSst.filter.sstIdDept',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'sstIdElocFilter',
        label: 'label.em.spareparts.emSppStorageSst.filter.sstIdEloc',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emSppLocation'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'sstKeeperIdUserFilter',
        label: 'label.em.spareparts.emSppStorageSst.filter.sstKeeperIdUser',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.spareparts.emSppStorageSst.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppStorageSst.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'sstIdSsc',
        label: 'label.em.spareparts.emSppStorageSst.entity.sstIdSsc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,required: true
            ,entity: 'emSppStorageCatSsc'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'sstIdDept',
        label: 'label.em.spareparts.emSppStorageSst.entity.sstIdDept',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'sstIdEloc',
        label: 'label.em.spareparts.emSppStorageSst.entity.sstIdEloc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,required: true
            ,entity: 'emSppLocation'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'sstKeeperIdUser',
        label: 'label.em.spareparts.emSppStorageSst.entity.sstKeeperIdUser',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'sstIdRemark',
        label: 'label.em.spareparts.emSppStorageSst.entity.sstIdRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppStorageSst, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
